module.exports = __webpack_public_path__ + "aaeb1a0639850eb167bc1d0ede9d38a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/griddle-components/images/inventory_placeholder.png
 ** module id = 1297
 ** module chunks = 0
 **/